import { FC } from 'react';

import winterSceneBg from './images/background.png';

/**
 * Winter Background
 * Uses body::before pseudo-element for reliable layering
 */
export const BackgroundTint: FC = () => {
	return (
		<style>
			{`
				/* Background via body::before - sits naturally behind #root content */
				.winter-theme body::before {
					content: '';
					position: fixed;
					top: 0;
					left: 0;
					width: 100vw;
					height: 100vh;
					background-color: #0a0f1a;
					background-image: 
						linear-gradient(180deg, rgba(10, 15, 30, 0.88) 0%, rgba(15, 25, 50, 0.82) 50%, rgba(10, 15, 30, 0.75) 100%),
						url("${winterSceneBg}");
					background-size: cover, 110% auto;
					background-position: center, 40% 60%;
					background-repeat: no-repeat, no-repeat;
					z-index: -1;
					pointer-events: none;
				}
				
				/* Ensure body itself is transparent */
				.winter-theme body {
					background: transparent !important;
				}

				/* Make main content wrappers transparent so background shows through */
				.winter-theme [data-testid="recognition-content-wrapper"],
				.winter-theme [data-testid="right-content-wrapper"],
				.winter-theme [data-testid="left-sidebar-wrapper"],
				.winter-theme [data-testid="right-content-centerer"],
				.winter-theme [data-testid="main-feed-column"],
				.winter-theme #nav-wrapper,
				.winter-theme #root > div {
					background: transparent !important;
					background-color: transparent !important;
				}
			`}
		</style>
	);
};
